import { type ReactNode } from 'react'
import { type DropzoneProps } from '@/hooks/dropzone-hook'
import styles from './JobCards.module.css'

export interface JobCardsProps {
  dropzoneProps?: DropzoneProps<HTMLDivElement>
  children: ReactNode
}

export function JobCards({ dropzoneProps, children }: JobCardsProps) {
  return (
    <div className={styles.container} {...dropzoneProps}>
      {children}
    </div>
  )
}
